import { render, staticRenderFns } from "./Puntos.vue?vue&type=template&id=e618066c"
import script from "./Puntos.vue?vue&type=script&lang=js"
export * from "./Puntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports